import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'eq-ar-communication-pref',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatSlideToggleModule],
  templateUrl: './communicationPrefArenaEQ.component.html',
  styleUrl: './communicationPrefArenaEQ.component.scss',
})
export class CommunicationPrefComponentArenaEQ implements OnInit{
  @Input() profileData!: any;
  @Output() changeCommunicationPrefHandler: EventEmitter<any> = new EventEmitter<any>();
  activeCommunicationTypes = new Set()
  ngOnInit(): void {
    this.activeCommunicationTypes = new Set(this.profileData?.activeCommunicationTypes ?? [])
  }
  toggleHandler(prefType: string, value: any){
    if(value.checked){
      this.activeCommunicationTypes.add(prefType);
    }else{
      this.activeCommunicationTypes.delete(prefType);
    }
    if(this.profileData){
      this.profileData.activeCommunicationTypes = Array.from(this.activeCommunicationTypes);
      this.changeCommunicationPrefHandler.emit({activeCommunicationTypes: this.profileData.activeCommunicationTypes})    
    }else{
      this.changeCommunicationPrefHandler.emit({activeCommunicationTypes: Array.from(this.activeCommunicationTypes)})    
    }
  }
}
